import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface TravelCostResults {
  region: string;
  distance: number;
  cost: number;
}
@Component({
    selector: 'infans-travelcost-simulator',
    templateUrl: './travelcost-simulator.component.html',
    styleUrls: ['./travelcost-simulator.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TravelcostSimulatorComponent {
  showSimulation = new BehaviorSubject(false);
  showAlert = false;
  showError = false;
  buttonDisabled = false;
  
  results: TravelCostResults[] = [];

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {

  }

  removeAlert() {
    this.showAlert = false;
    this.changeDetectorRef.markForCheck();
  }

  distanceCalculator(address: HTMLInputElement) {
    if (!!address.value) {
      this.buttonDisabled = true;
      this.showError = false;
      this.showSimulation.next(false);
      this.changeDetectorRef.markForCheck();

      const req: google.maps.DistanceMatrixRequest = {
        avoidFerries: true,
        avoidHighways: false,
        avoidTolls: true,
        drivingOptions: {
          departureTime: new Date(null),
          trafficModel: google.maps.TrafficModel.OPTIMISTIC
        },
        destinations: [address.value],
        origins: [
          'Tijmstraat 23, 3990 Peer',
          'Kruisdijk 21, 3990 Peer',
          'Heggebossenweg 6, 3980 Tessenderlo-Ham',
        ],
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.METRIC
      };
      const regionOrigins = ['regio Peer', 'regio Peer', 'regio Tessenderlo'];

      new google.maps.DistanceMatrixService().getDistanceMatrix(req, resp => {

        const distances: { region: string, distance: number }[] = [];
        resp.rows?.forEach((row, index) => {
          row.elements.forEach(element => {
            if (google.maps.DistanceMatrixElementStatus.OK === element.status) {
              const region = regionOrigins[index];
              distances.push({ region, distance: element.distance.value});
            }
          });
        });

        if (distances.length > 0) {
          this.results = distances
            .sort((n1, n2) => n1.distance - n2.distance)
            .filter((item, index, self) => index === self.findIndex((t) => t.region === item.region))
            .map(item => {
              const distanceRounded = Math.round(item.distance / 100) / 10;
              return {
                region: item.region,
                distance: distanceRounded,
                cost: distanceRounded >= 20 ? Math.floor((distanceRounded - 10) / 5) * 5 : 0
              }
            });
          this.showSimulation.next(true);
        } else {
          this.showError = true;
        }
        this.buttonDisabled = false;
        this.showAlert = true;
        this.changeDetectorRef.markForCheck();
      });
    }
  }
}
